import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import type { ICountrySiteBannerProps } from './C20-country-site-banner';

const CountrySiteBanner = lazy(async () => import('./C20-country-site-banner'));

const el = '.fa-component--country-site-banner';
const DOM: HTMLElement = document.querySelector(el)!;

const render = function () {
    if (DOM) {
        const props = JSON.parse(DOM.dataset.props ?? '{}') as ICountrySiteBannerProps;
        const labels = JSON.parse(DOM.dataset.labels ?? '{}') as { close: string };

        createRoot(DOM).render(
            <CountrySiteBanner
                header={props.header}
                subHeader={props.subHeader}
                visitCountrySiteButtonLabel={props.visitCountrySiteButtonLabel}
                visitCountrySiteUrl={props.visitCountrySiteUrl}
                countrySelectorList={props.countrySelectorList}
                closableBanner={props.closableBanner}
                closeBannerLabel={labels.close}
            />,
        );
    }
};

export default {
    render,
};
